module.exports = __webpack_public_path__ + "img/handraw_besoin d'aide.5ad35636.svg";